import { render, staticRenderFns } from "./ContMyReportsGdsComponent.vue?vue&type=template&id=4ee9af38&scoped=true&lang=pug"
import script from "./ContMyReportsGdsComponent.vue?vue&type=script&lang=js"
export * from "./ContMyReportsGdsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee9af38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ee9af38')) {
      api.createRecord('4ee9af38', component.options)
    } else {
      api.reload('4ee9af38', component.options)
    }
    module.hot.accept("./ContMyReportsGdsComponent.vue?vue&type=template&id=4ee9af38&scoped=true&lang=pug", function () {
      api.rerender('4ee9af38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/my_objects/components/ContMyReportsGdsComponent.vue"
export default component.exports